import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=533a6cc1&scoped=true"
import script from "./RoleTree.vue?vue&type=script&lang=js"
export * from "./RoleTree.vue?vue&type=script&lang=js"
import style0 from "./RoleTree.vue?vue&type=style&index=0&id=533a6cc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a6cc1",
  null
  
)

export default component.exports